<template>
    <div>
        <Table border :columns="columns" :data="data" ref="Table" id="Table" :loading="loading">
            <template slot-scope="{ row, index }" slot="businessUnit" style="width:100%">
                <Select v-model="row.businessUnit" :transfer="true" @on-change="targetItemChange(row, index, 'businessUnit')">
                    <Option v-for="item in businessUnitList" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                </Select>
            </template>
            <template slot-scope="{ row, index }" slot="department" style="width:100%">
                <Select v-model="row.department" :transfer="true" @on-change="targetItemChange(row, index, 'department')">
                    <Option v-for="item in departmentList" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                </Select>
            </template>
            <template slot-scope="{ row, index }" slot="postFun">
                <Select v-model="row.postFun" :transfer="true" @on-change="targetItemChange(row, index, 'postFun')">
                    <Option v-for="item in funcationList" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                </Select>
            </template>
            <template slot-scope="{ row, index }" slot="stiTarget">
                <Input type="textarea" v-model="row.stiTarget" :autosize="true" @on-change="targetItemChange(row, index, 'stiTarget')"/>
            </template>
            <template slot-scope="{ row, index }" slot="details">
                <Input type="textarea" v-model="row.details" :autosize="true" @on-change="targetItemChange(row, index, 'details')" />
            </template>
            <template slot-scope="{ row, index }" slot="milepost1">
                <Input type="textarea" v-model="row.milepost1" :autosize="true" @on-change="targetItemChange(row, index, 'milepost1')" />
            </template>
            <template slot-scope="{ row, index }" slot="milepost2">
                <Input type="textarea" v-model="row.milepost2" :autosize="true" @on-change="targetItemChange(row, index, 'milepost2')"/>
            </template>
            <template slot-scope="{ row, index }" slot="milepost3">
                <Input type="textarea" v-model="row.milepost3" :autosize="true"  @on-change="targetItemChange(row, index, 'milepost3')" />
            </template>
            <template slot="action1" slot-scope="{ row, index }">
                <Button size="small" @click="onSaveRow(row,index)"><!-- 保存 -->{{$t('Save')}}</Button>
                <Button type="error" size="small"  @click="onDeleteRow(row,index)"><!-- 删除 -->{{$t('Delete')}}</Button>
            </template>
            <template slot="action2" slot-scope="{ row, index }">
                <Button icon="ios-redo" size="small" :disabled="!row.id" @click="onShare(row,index)"></Button>
                <!-- <Icon size="44" color="#8CD29B" type="ios-redo" @click="onShare" /> -->
            </template>
        </Table>
        <div style="display: flex;justify-content: space-between;margin-top: 30px;">
            <Page :total="total" @on-change="pageChange"></Page>
            <div>
                <!-- <Button @click="targetModal = true">批量设置绩效目标</Button> -->
                <Button style="margin-left:15px" @click="addItem()"><!-- 新增 -->{{$t('Add')}}</Button>
                <Button style="margin-left:15px" @click="handelFile"><!-- 导出 -->{{$t('Import_Insert')}}</Button>
                <input type="file" ref="uploadExcel" accept=".xlsx,.xls" id="excel-filea" @change="importExcel" v-show="false">
                <Button style="margin-left:15px" @click="exportData()"><!-- 导出 -->{{$t('Export_Formwork')}}</Button>
            </div>
        </div>
        <ShareUser ref="ShareUser" @onSelectList="onSelectList"></ShareUser>
        <Modal v-model="targetModal" title="批量设置绩效目标" width="350">
            <div>
                <Button>{{$t('DownLoad_Formwork')}}</Button>
                <div style="display:flex;margin-top:20px">
                <Upload :action="action" ref="my-upload" :on-success="uploadSuccess" :show-upload-list="false">
                    <Button icon="ios-cloud-upload-outline">{{$t('Upload_File')}}</Button>
                </Upload>
                <span style="margin-left:20px">{{ filename }}</span>
                </div>
            </div>
            <div slot="footer">
                <Button @click="targetModal = false">{{$t('Cancel')}}</Button>
                <Button @click="targetModal = false">{{$t('Save')}}</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import ShareUser from "./ShareUser.vue";
import axios from 'axios'
export default {
    components:{ShareUser},
    data(){
        return{
            loading:false,
            modal: false,
            dateYear: new Date().getFullYear(),
            positionList:[],
            departmentList:[],
            businessUnitList:[],
            funcationList:[],
            TargetType:[],
            pageInfo: {
                itemCount: 0,
                pageNo: 1,
                pageSize: 10,
            },
            total: 0,
            data: [],
            targetModal: false,
            action: "/api/resource/upload",
            filename: "",
            shareId:'',
            rowyear:''
        }
    },
    computed:{
        columns(){
            return [
                {
                    title: this.$t('Year'),/* 年度 */
                    key: "year",
                    align: "center",
                    minWidth: 80,
                    fixed: 'left'
                },{
                    title: this.$t('BU'),/* 业务单元 */
                    key:'businessUnitVal',
                    slot: "businessUnit",
                    align: "center",
                    minWidth: 170
                },{
                    title: this.$t('Department'),/* 部门 */
                    key:'departmentVal',
                    slot: "department",
                    align: "center",
                    minWidth: 170
                },{
                    title: this.$t('Funciton'),/* 职能 */
                    key:'postFunVal',
                    slot: "postFun",
                    align: "center",
                    minWidth: 140
                },{
                    title: this.$t('STI_Self'),/* STI个人目标 */
                    key: "stiTarget",
                    slot: "stiTarget",
                    align: "center",
                    minWidth: 130
                },{
                    title: this.$t('Detailed_Description'),/* 详细描述 */
                    key: "details",
                    slot: "details",
                    align: "center",
                    minWidth: 250
                },{
                    title: this.$t('Milestone1'),/* 里程碑1 */
                    key: "milepost1",
                    slot: "milepost1",
                    align: "center",
                    minWidth: 120
                },{
                    title: this.$t('Milestone2'),/* 里程碑2 */
                    key: "milepost2",
                    slot: "milepost2",
                    align: "center",
                    minWidth: 120
                },{
                    title: this.$t('Milestone3'),/* 里程碑3 */
                    key: "milepost3",
                    slot: "milepost3",
                    align: "center",
                    minWidth: 120
                },{
                     title: this.$t('Action'),/* 操作 */
                    slot: "action1",
                    align: "center",
                    minWidth: 140,
                    fixed: 'right'
                },{
                    title: this.$t('Share'),/* 分享 */
                    slot: "action2",
                    align: "center",
                    minWidth: 80,
                    fixed: 'right'
                }
            ]
        },
        lang(){
            return this.$store.getters.selectLangeData
        }
    },
    created(){
        // this.getData()
    },
    methods: {
        getData(){
            let obj={
                ...this.formItem,
                ...this.pageInfo
            }
            this.loading=true
            axios.post("/achTargetSetting/selectAchStiInfoList", obj).then((res) => {
                this.loading=false
                if(res){
                    this.data=res.data
                    this.total = parseInt(res.pageInfo.total)
                }
            })
        },
        addItem(){
            this.data.push({
                year:this.dateYear,
                businessUnit:JSON.parse(sessionStorage.getItem('userInfo')).orgcode2,
                department:JSON.parse(sessionStorage.getItem('userInfo')).orgcode3,
                postFun:JSON.parse(sessionStorage.getItem('userInfo')).orgcode4,
                stiTarget:'',
                details:'',
                milepost1:'',
                milepost2:'',
                milepost3:'',
            })
        },
        onShare(row,index) {
            this.$refs.ShareUser.modal = true;
            this.$refs.ShareUser.id = row.id;
            this.$refs.ShareUser.targetType='1'
            this.shareId=row.id
            console.log(this.shareId)
            this.$refs.ShareUser.getData()
            this.rowyear=row.year
        },
        onSelectList(list){
            let obj={
                id:this.shareId,
                typeFlag:'2',
                empList:list,
                year:this.rowyear,
            }
            this.$refs.ShareUser.loading=true
            axios.post("/achTargetSetting/shareAchTargetInfo", obj).then((res) => {
                if(res){
                    this.$refs.ShareUser.loading=false
                    this.$refs.ShareUser.modal=false
                    this.$Message.success(this.$t(res));
                    this.getData()
                    this.$nextTick(() => {
                        this.$refs.ShareUser.$refs.selection.selectAll(false);
                    })
                }
            })
        },
        targetItemChange(row, index, key) {
            key && this.$set(this.data[index], key, row[`${key}`]);
        },
        onSaveRow(row,index) {
            axios.post("/achTargetSetting/saveAchStiSetting", row).then((res) => {
                if(res){
                    this.$Message.success(this.$t(res));
                    this.getData()
                }
            })
        },
        onDeleteRow(row,index) {
            if(row.count>0 && row.id){
                this.$Modal.confirm({
                    title: this.$t('Delete_Share'),
                    onOk: () => {
                        axios.post("/achTargetSetting/deleteAchStiSetting", {id:row.id}).then((res) => {
                            if(res){
                                this.$Message.success(res);
                                this.getData()
                            }
                        })
                    }
                })
            }else {
                this.$Modal.confirm({
                    title: this.$t('Are_you_sure_to_delete'),
                    onOk: () => {
                        if(row.id){
                            axios.post("/achTargetSetting/deleteAchStiSetting", {id:row.id}).then((res) => {
                                if(res){
                                    this.$Message.success(res);
                                    this.getData()
                                }
                            })
                        }else {
                            this.data.splice(index,1)
                        }
                    }
                })
            }
        },
        uploadSuccess(val, file) {
            this.filename = file.name;
        },
        pageChange(val){
            this.pageInfo.pageNo = val;
            this.getData()
        },
        handelFile() {
            this.$refs.uploadExcel.click();
        },
        importExcel(e) {
            var file_name = document.getElementById('excel-filea').value
            file_name = file_name.substring(file_name.lastIndexOf(".")).toLowerCase()
            var uploadFormat = ['.xlsx','.xls']
            if (file_name != uploadFormat[0] && file_name != uploadFormat[1]) {
                this.$Message.warning({
                    content: '文件类型不正确, 请选择' + uploadFormat.join(' or ') + '类型',
                    duration: 5
                })
                return
            }
           
             this.$importExcel('excel-filea',e,'Table',async (data) => {
                 this.loading=true
                // this.data = this.data.concat(data)
                await data.forEach(el => {
                    
                    el.businessUnit=this.businessUnitList.filter(
                        item => (el.businessUnitVal == item.code ||  el.businessUnitVal == item.ch_value || el.businessUnitVal == item.en_value)
                        ).map(res => res.code)[0]
                    el.department=this.departmentList.filter(
                        item => (el.departmentVal == item.code ||  el.departmentVal == item.ch_value || el.departmentVal == item.en_value)
                        ).map(res => res.code)[0]
                    el.postFun=this.funcationList.filter(
                        item => (el.postFunVal == item.code ||  el.postFunVal == item.ch_value || el.postFunVal == item.en_value)
                        ).map(res => res.code)[0]
                    if(!el.businessUnit || !el.department || !el.postFun){
                        // this.$Message.error('导入内容有误,需请从页面从新选择')
                        el.flag='1'
                    }
                })
                axios.post("/achTargetSetting/reportAchStiSetting", data).then((res) => {
                    this.loading=false
                    if (res) {
                        this.$Message.success(res);
                    }
                    this.getData()
                });
            })
        },
        exportData(){
            this.data.forEach(el => {
                el.businessUnitVal=this.businessUnitList.filter(
                    item => el.businessUnit == item.code
                    ).map(res => (this.lang=='zh'?res.ch_value:res.en_value))[0]
                el.departmentVal=this.departmentList.filter(
                    item => el.department == item.code
                    ).map(res => (this.lang=='zh'?res.ch_value:res.en_value))[0]
                el.postFunVal=this.funcationList.filter(
                    item => el.postFun == item.code
                    ).map(res => (this.lang=='zh'?res.ch_value:res.en_value))[0]
            })
            this.$nextTick(() => {
                this.$exportExcel('Table','STI个人目标'+this.$nowDate.dateVal(new Date(),'YYYY-MM-DD HH-mm'))
            })
            
            // this.$refs.Table.exportCsv({
            //     filename: 'STI个人目标',
            // });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/process/performanceManagement/AchTargetSettingComponents/STIComponent.vue